import { Box, BoxProps } from '@mui/material'

import { styled } from '@mui/material/styles'

interface DraggableBoxProps extends BoxProps {
  'data-is-dragging': boolean
}

export const DraggableBox = styled(Box)<DraggableBoxProps>(
  ({ theme, 'data-is-dragging': isDragging }) => ({
    padding: theme.spacing(1),
    backgroundColor: isDragging ? theme.colors.neutral.softGray : 'initial',
    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
    boxShadow: isDragging
      ? `0px 6px 20px 0px ${theme.colors.action.hoverShadow}`
      : 'initial',
    borderRadius: theme.spacing(1),
    marginBottom: theme.spacing(1),
  }),
)
